<template>
    <div class="admin-dashboard-site-content">
        <el-menu
            class="dashboard-menu"
            text-color="#fff"
            active-text-color="#fff"
            :router="true"
            :default-active="$route.path"
        >
            <el-menu-item
                v-for="item in menuItems"
                :key="item.route"
                :index="item.route"
            >
                <i :class="item.icon"></i>
                <span slot="title">{{item.title}}</span>
            </el-menu-item>
            <!-- <el-menu-item index="/admin-dashboard/site_content">
                <i class="el-icon-document"></i>
                <span slot="title">Sliders</span>
            </el-menu-item>
            <el-menu-item index="/admin-dashboard/site_content/sub_content">
                <i class="el-icon-document"></i>
                <span slot="title">Home Page Content</span>
            </el-menu-item>
            <el-menu-item index="/admin-dashboard/site_content/document">
                <i class="el-icon-document"></i>
                <span slot="title">Documents</span>
            </el-menu-item>
            <el-menu-item index="/admin-dashboard/site_content/faq">
                <i class="el-icon-document"></i>
                <span slot="title">FAQs</span>
            </el-menu-item>
            <el-menu-item index="/admin-dashboard/site_content/privacy">
                <i class="el-icon-document"></i>
                <span slot="title">Privacy policy</span>
            </el-menu-item>
            <el-menu-item index="/admin-dashboard/site_content/tc">
                <i class="el-icon-document"></i>
                <span slot="title">Terms & Conditions</span>
            </el-menu-item> -->
        </el-menu>
        <div class="admin-dashboard-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "AdminSiteContentSettings",
    components: {
    },
    data() {
        return {
            processing: false,
            showNew: false,
            showDetail: false,
            selectedData: null
        };
    },
    mounted() {
    },
    computed: { 
        ...mapState({
            adminPerms: state => state.adminPerms,
        }),
        menuItems() {
            let menus = [];
            if(this.adminPerms && this.adminPerms.content && this.adminPerms.content.length > 0 && this.adminPerms.content[0].visibility) {
                if(this.adminPerms.content[0].sliders) {
                    menus.push({
                        title: "Sliders",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content",
                    });
                }
                if(this.adminPerms.content[0].sub_content) {
                    menus.push({
                        title: "Home Page Contents",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/sub_content",
                    });
                }
                if(this.adminPerms.content[0].documents) {
                    menus.push({
                        title: "Documents",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/document",
                    });
                }
                if(this.adminPerms.content[0].faqs) {
                    menus.push({
                        title: "FAQs",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/faq",
                    });
                }
                if(this.adminPerms.content[0].privacy) {
                    menus.push({
                        title: "Privacy Policy",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/privacy",
                    });
                }
                if(this.adminPerms.content[0].tc) {
                    menus.push({
                        title: "Terms & conditions",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/tc",
                    });
                }
                if(this.adminPerms.content[0].templates_email) {
                    menus.push({
                        title: "Email Templates",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/email_template",
                    });
                }
                if(this.adminPerms.content[0].templates_notice) {
                    menus.push({
                        title: "Notices",
                        icon: "el-icon-document",
                        route: "/admin-dashboard/site_content/notice",
                    });
                }
            }
            return menus;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
    }
};
</script>
<style scoped>
.el-menu-item.is-active {
    background-color: #005179;
}
.el-menu {
    height: 100%;
    background-color: #005986;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
    width: 200px;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: rgba(0, 0, 0, 0.3);
}

.admin-dashboard-site-content {
    width: 100%;
    height: 100%;
    display: flex;
}
.admin-dashboard-content{
    flex: 1;
    overflow: auto;
}
.admin-dashboard-site-content h2 {
    color: #555;
}
</style>